/**
 * Created by Languagenut on 17/09/2019.
 */


import React  from 'react';
import {Card , Badge} from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next';
import Table from '../general_table.js';
import Translation from '../../store/internationalization-store.js'
export default class Highscore extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            data: this.props.data
        }
    }

    componentWillReceiveProps(props){
        this.props  = props;
        this.setState({update:true});
    }

    badge(cell , row){
        if(Number(row.rank) <= 3 )
        {
            return <h5><Badge variant="primary" >{cell}</Badge></h5>;
        }

        return <h5><Badge variant="primary" >{cell}</Badge></h5>;
    }

    render(){
        //(rank, name, score)
        const columns = [
            {
                dataField: 'rank',
                text: Translation.get(12690 , 'Rank'),
                align:"left",
                classes:"mono",
                formatter:this.badge,
                headerClasses:"hide",
            } , {
                dataField: 'name',
                text: this.props.isStudent ? Translation.get(827 , 'Student Name') : Translation.get(15, 'School Name'),
                align:"left",
                headerClasses:"hide",
                formatter:(cell , row)=>{

                    if(row.isUser == '1')
                    {
                        return <strong>{cell}</strong>
                    }

                    return cell
                }
            } , {
                dataField: 'score',
                headerClasses:"hide",
                text: Translation.get(229 , 'Score'),
                align:"right",
                classes:"mono",
                formatter:this.shouldBold
            }];


        const rowStyle2 = (row, rowIndex) => {

            const style = {
                border:'1.5px solid #1f1535',
                borderColor:'#1f1535',
                borderWidth:'1.5px'
            };

            console.log(rowIndex)
            if (rowIndex == 0 ) {
                style.backgroundColor = '#fcdfad';
            }

            if (rowIndex == 1 ) {
                style.backgroundColor = '#e5e3e5';
            }

            if (rowIndex == 2 ) {
                style.backgroundColor = '#f4b796';
            }

            /*  if (rowIndex > 2) {
             style.fontWeight = 'bold';
             style.color = 'white';
             }*/

            return style;
        };

        const rowClasses = (row, rowIndex) => {
            let classes = '';


            if(rowIndex == 0)
            {
                classes = 'animated pulse delay-1s';
            }

            if(rowIndex == 1)
            {
                classes = 'animated pulse delay-2s';
            }

            if(rowIndex == 2)
            {
                classes = 'animated pulse delay-3s';
            }

            if (row.is_class) {
                classes = 'highlight-table-row';
            }

            return classes;
        };

        return  <Card body>
                <h6><b>{this.props.title}</b></h6>
                <Table limit={5} hideDownload hideSearch noBoarder rowStyle={ rowStyle2 } rowClasses={ rowClasses }   bordered={ false }  bordered={ false }  keyField="uid" columns={columns} data={this.props.data}/>
            </Card>

    }
}